import { CommonModule } from '@angular/common';
import { Component, Input, OnInit, ViewEncapsulation } from '@angular/core';
import { FormBuilder, ReactiveFormsModule, Validators } from '@angular/forms';
import { LabReqBaseComponent } from '../lab-req-base/lab-req-base.component';

@Component({
  standalone: true,
  imports: [CommonModule, ReactiveFormsModule],
  encapsulation: ViewEncapsulation.ShadowDom,
  selector: 'app-lab-req-bc',
  templateUrl: './lab-req-bc.component.html',
  styleUrls: ['./lab-req-bc.component.less']
})
export class LabReqBcComponent extends LabReqBaseComponent implements OnInit {
  constructor(private fb: FormBuilder) {
    super();
  }

  ngOnInit() {
    this.initForm();
  }

  onLifelabsFastingNoChange(checked: boolean) {
    if (checked) {
      this.form.get('LIFELABS')?.patchValue({ fastingYes: false, fastingHours: '' }, { emitEvent: false });
    }
  }

  onLifelabsFastingYesChange(checked: boolean) {
    if (checked) {
      this.form.get('LIFELABS')?.patchValue({ fastingNo: false }, { emitEvent: false });
    }
  }

  initForm() {
    this.form = this.fb.group({
      surname: ['', Validators.required],
      first: ['', Validators.required],
      initials: ['', Validators.required],
      dob: this.fb.group({
        day: ['', Validators.required],
        month: ['', Validators.required],
        year: ['', Validators.required]
      }),
      sex: this.fb.group({
        male: [false],
        female: [false]
      }),
      billing: this.fb.group({
        MSP: [false],
        ICBC: [false],
        workSafeBC: [false],
        patient: [false],
        other: this.fb.group({
          yes: [false],
          value: ['']
        }),
        PHN: ['', Validators.required],
        idNumber: ['']
      }),
      chartNumber: [''],
      roomNumber: [''],
      address: this.fb.group({
        patientAddress: ['', Validators.required],
        cityProvince: ['', Validators.required],
        postalCode: ['', Validators.required]
      }),
      patientTel: ['', Validators.required],
      practitionerNumber: ['', Validators.required],
      locumFor: this.fb.group({
        physician: [''],
        MSC: ['']
      }),
      c0Number: [''],
      dateOfCollection: [''],
      phlebotomist: [''],
      dataEntry: [''],
      medication: [''],
      copyTo: [''],
      pregnant: this.fb.group({
        yes: [false],
        no: [false]
      }),
      fasting: this.fb.group({
        yes: [false],
        hoursPrior: ['']
      }),
      phoneFax: this.fb.group({
        phone: [false],
        fax: [false],
        value: ['']
      }),
      telephoneRequisitionReceivedBy: [''],
      diagnosis: [''],
      standingOrderRequests: [''],
      date: [''],
      signature: [''],
      HEMATOLOGY: this.fb.group({
        hematologyProfile: [false],
        INR: [false],
        ferritin: [false],
        anticoagulant: this.fb.group({
          yes: [false],
          no: [false],
          specify: ['']
        }),
        HFE: this.fb.group({
          confirmDiagnosis: [false],
          siblingParent: [false]
        })
      }),
      MICROBIOLOGY: this.fb.group({
        ROUTINE_CULTURE: this.fb.group({
          antibiotics: this.fb.group({
            yes: [false],
            no: [false],
            specify: ['']
          }),
          throat: [false],
          sputum: [false],
          blood: [false],
          urine: [false],
          superficialWound: this.fb.group({
            yes: [false],
            site: ['']
          }),
          deepWound: this.fb.group({
            yes: [false],
            site: ['']
          }),
          other: this.fb.group({
            yes: [false],
            value: ['']
          })
        }),
        VAGINITIS: this.fb.group({
          initial: [false],
          chronicRecurrent: [false],
          trichomonasTesting: [false]
        }),
        GROUP_B_STREP_SCREEN: this.fb.group({
          vaginoAnorectalSwab: [false],
          penicillinAllergy: [false]
        }),
        CHLAMYDIA_GONORRHEA_NAAT: this.fb.group({
          urethra: [false],
          cervix: [false],
          urine: [false],
          vagina: [false],
          throat: [false],
          rectum: [false],
          other: this.fb.group({
            yes: [false],
            value: ['']
          })
        }),
        GONORRHEA_CULTURE: this.fb.group({
          cervix: [false],
          urethra: [false],
          throat: [false],
          rectum: [false],
          other: this.fb.group({
            yes: [false],
            value: ['']
          })
        }),
        STOOL_SPECIMENS: this.fb.group({
          historyOfBloodyStools: [false],
          cDifficileTesting: [false],
          stoolCulture: [false],
          stoolOva: [false],
          stoolOva2: [false]
        }),
        DERMATOPHYTES: this.fb.group({
          dermatophyteCulture: [false],
          KOH: [false],
          skin: [false],
          nail: [false],
          hair: [false],
          site: ['']
        }),
        MYCOLOGY: this.fb.group({
          yeast: [false],
          fungus: [false],
          site: ['']
        })
      }),
      URINE_TESTS: this.fb.group({
        macroscopic1: [false],
        macroscopic2: [false],
        macroscopic3: [false],
        microscopic: [false],
        info: ['']
      }),
      CHEMISTRY: this.fb.group({
        glucoseFasting: [false],
        glucoseRandom: [false],
        GTT1: [false],
        GTT2: [false],
        GTT3: [false],
        hemoglobin: [false],
        ACR: [false],
        LIPIDS: this.fb.group({
          fullLipidProfile: [false],
          followUpLipidProfile: [false],
          apoB: [false]
        }),
        THYROID_FUNCTION: this.fb.group({
          TSH: [false],
          TSH_fT4: [false],
          TSH_fT4_fT3: [false]
        }),
        OTHER_CHEMISTRY_TESTS: this.fb.group({
          sodium: [false],
          eGFR: [false],
          potassium: [false],
          calcium: [false],
          albumin: [false],
          CK: [false],
          alkPhos: [false],
          PSA1: [false],
          ALT: [false],
          B12: [false],
          PSA2: [false],
          bilirubin: [false],
          pregnancyTest: [false],
          GGT: [false],
          bHCG: [false],
          tProtein: [false]
        })
      }),
      HEPATITIS_SEROLOGY: this.fb.group({
        acuteHepatitis: [false],
        chronicHepatitis: [false],
        hepatitisA: [false],
        hepatitisB: [false],
        HBsAg: [false]
      }),
      HIV_SEROLOGY: this.fb.group({
        HIV_serology: [false],
        nonNominalReporting: [false]
      }),
      OTHER_TESTS: this.fb.group({
        ECG: [false],
        FIT1: [false],
        FIT2: [false]
      }),
      LIFELABS: this.fb.group({
        danTalya: [true],
        psaTotal: [false],
        shbg: [true],
        vitaminD25: [true],
        fastingNo: [true],
        fastingYes: [false],
        fastingHours: [''],
        diagnosisComments: [''],
      })
    });
  }
}